import React from 'react';
import Spinner from 'react-spinkit';

import { connect } from 'react-redux';
import Cookies from 'js-cookie';

import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';

import { getDeviceId } from '../util/device';

import { FETCH_DEVICE_SUCCESS, DELETE_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
import { generateDeviceId, storeHistory, mobileDeviceId } from '../store/actions/appActions';

import { fetchDevice, deleteDevice } from '../store/actions/deviceActions';
import { fetchUser, clearUser } from '../store/actions/userActions';
import { fireAnalytics } from './utils';
import {
  fetchFeaturedPlaylist,
  fetchUserPlaylists,
  fetchHomePlaylist,
  fetchMyPlaylist,
  fetchActivePlaylist,
  clearFeaturedPlaylist,
  clearUserPlaylists,
  clearActivePlaylist,
} from '../store/actions/playlistActions';
import { fetchSubscription, clearSubscription } from '../store/actions/subscriptionActions';


export class SplashScreen extends React.Component {
  async componentDidMount() {
    this.loadData();
  }

  getPlatformInformation() {
    const that = this;
    function successCb(cbObject) {
      console.log(`[Platform Info] : ${JSON.stringify(cbObject)}`);
      localStorage.setItem('DeviceID', cbObject.serialNumber);
      that.loadData();
    }

    function failureCb(cbObject) {
      const { errorCode } = cbObject;
      const { errorText } = cbObject;

      console.log(`Error Code [${errorCode}]: ${errorText}`);
    }

    const deviceInfo = new DeviceInfo();
    deviceInfo.getPlatformInfo(successCb, failureCb);
  }

  async logout() {
    try {
      const response = await this.props.deleteDevice(this.props.device.data.id);
      this.props.clearFeaturedPlaylist();
      this.props.clearUserPlaylists();
      this.props.clearActivePlaylist();
      this.props.clearUser();
      this.props.clearSubscription();
      localStorage.removeItem('DeviceID');
      Cookies.remove('auth__token');
      if (response.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
      if (response.type === DELETE_DEVICE_SUCCESS) {
        this.props.history.push('/pair');
      }
    } catch (e) {
      console.log(e);
    }
  }

  async loadData() {
    try {
      const deviceId = getDeviceId();
      fireAnalytics('Launch', 'Starting App', deviceId);
      if (localStorage.getItem('firstLaunchedAt') === null) {
        localStorage.setItem('firstLaunchedAt', new Date());
      }
      await this.props.storeHistory(this.props.history);
      if (!this.props.app.LGDeviceId) {
        this.props.generateDeviceId(deviceId);
      }
      localStorage.setItem('DownloadInfo', null);
      const deviceResult = await this.props.fetchDevice(this.props.app.LGDeviceId);
      if (deviceResult.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
      if (deviceResult.type === FETCH_DEVICE_SUCCESS) {
        const emailId = deviceResult.payload._embedded.user.email;
        const userId = deviceResult.payload._embedded.user.id;
        await this.props.mobileDeviceId(userId);
        // TODO: Move this into a redux action.
        //         if (bdAuth.getToken()) {
        const response = await bdReq.post('/emailLogin', { emailId });
        if (response.success) {
          bdAuth._storeToken(response.body);
        }
        //         }
        if ((localStorage.getItem('deleteCredentials') && localStorage.getItem('deleteCredentials') === 'true') || localStorage.getItem('deleteCredentials') === null) {
          this.logout();
          return;
        }
        const fetchUser = await this.props.fetchUser();
        if (fetchUser.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }

        const fetchSubscription = await this.props.fetchSubscription();
        if (fetchSubscription.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }

        const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
        if (fetchFeaturedPlaylist.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }

        const fetchHomePlaylist = await this.props.fetchHomePlaylist();
        if (fetchHomePlaylist.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }

        const fetchMyPlaylist = await this.props.fetchMyPlaylist();
        if (fetchMyPlaylist.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }

        // const fetchActivePlaylist = await this.props.fetchActivePlaylist('Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
        const fetchActivePlaylist = await this.props.fetchActivePlaylist(
          this.props.activePlaylist.data.id !== undefined
            ? this.props.activePlaylist.data.id
            : '9363149b-09a6-48c6-a1d0-6ba28bfd4e7a'
        );
        if (fetchActivePlaylist.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        } if (fetchActivePlaylist.errors === 'No Artworks') {
          const fetchActivePlaylistAgain = await this.props.fetchActivePlaylist(
            '9363149b-09a6-48c6-a1d0-6ba28bfd4e7a'
          );
          if (fetchActivePlaylistAgain.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
        }

        const playlists = await this.props.fetchUserPlaylists();
        if (playlists.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }

        let targetPlaylistId;
        if (this.props.activePlaylist.data.id) {
          targetPlaylistId = this.props.activePlaylist.data.id;
        } else {
          targetPlaylistId = '9363149b-09a6-48c6-a1d0-6ba28bfd4e7a';
        }

        await this.props.fetchActivePlaylist(targetPlaylistId);
        setTimeout(() => {
          this.props.history.push(`/playlist/${targetPlaylistId}`);
        }, 10);
      } else {
        this.props.clearFeaturedPlaylist();
        this.props.clearUserPlaylists();
        this.props.clearActivePlaylist();
        this.props.clearUser();
        this.props.clearSubscription();
        Cookies.remove('auth__token');
        Cookies.remove('artwork_Interval');
        const emailId = 'lg-oled@blackdove.com';
        const response = await bdReq.post('/emailLogin', { emailId });
        if (response.success) {
          console.log(response);
          bdAuth._storeToken(response.body);
        }
        const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
        if (fetchFeaturedPlaylist.type === 'FETCH_FEATURED_PLAYLIST_FAILURE') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        } if (fetchFeaturedPlaylist.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const fetchHomePlaylist = await this.props.fetchHomePlaylist();
        if (fetchHomePlaylist.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        const fetchMyPlaylist = await this.props.fetchMyPlaylist();
        if (fetchMyPlaylist.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        setTimeout(() => {
          this.props.history.push('/pair');
        }, 10);
      }
    } catch (e) {
      console.log('e', e);
    }
  }

  render() {
    return (
      <div className="SplashPage">
        <div className="SplashWrapper">
          <img className="Logo" src="assets/img/blackdove-logo-2020.png" alt="" />
          <Spinner name="folding-cube" color="white" fadeIn="none" style={{ width: '40px', height: '40px' }} />
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  generateDeviceId: (deviceId) => dispatch(generateDeviceId(deviceId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  deleteDevice: (deviceId) => dispatch(deleteDevice(deviceId)),
  storeHistory: (history) => dispatch(storeHistory(history)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchUserPlaylists: () => dispatch(fetchUserPlaylists()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  clearFeaturedPlaylist: () => dispatch(clearFeaturedPlaylist()),
  clearUserPlaylists: () => dispatch(clearUserPlaylists()),
  clearActivePlaylist: () => dispatch(clearActivePlaylist()),
  clearUser: () => dispatch(clearUser()),
  clearSubscription: () => dispatch(clearSubscription()),
});
export default connect((state) => {
  const { app, activePlaylist, device } = state;
  return {
    app,
    device,
    activePlaylist,
  };
}, mapDispatchToProps)(SplashScreen);
